import { render, staticRenderFns } from "./Difficulty.vue?vue&type=template&id=8a5709be&scoped=true"
import script from "./Difficulty.vue?vue&type=script&lang=js"
export * from "./Difficulty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5709be",
  null
  
)

export default component.exports